import { computed } from 'vue';
import { useWindowSize, useElementBounding } from '@vueuse/core';

const Y_OFFSET = 50; // Adjust this value as needed

export const useUESettings = el => {
  const { width, height } = useWindowSize();
  const { width: elWidth, height: elHeight, x, y } = useElementBounding(el);

  return computed(() => ({
    xWindowSize: parseInt(width.value, 10),
    yWindowSize: parseInt(height.value, 10),
    xSize: parseInt(elWidth.value, 10),
    ySize: parseInt(elHeight.value, 10),
    xCenter: Math.ceil(x.value + elWidth.value / 2, 10) - 1,
    yCenter: parseInt(y.value + elHeight.value / 2, 10) + Y_OFFSET
  }));
};
